import {useState, useEffect} from 'react'
import type React from 'react'
import {createPortal} from 'react-dom'
import {AppHeaderV2} from 'pepsico-ds'
import type {IHeaderProps} from 'pepsico-ds'
import HelpSupportPopover from '@/components/common/HelpSupportPopover'

type AppHeaderV2WrapperProps = IHeaderProps

const AppHeaderV2Wrapper: React.FC<AppHeaderV2WrapperProps> = props => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    // The GDS AppHeaderV2 does not expose a slot for custom utility icons.
    // Inject a portal container into the header's right-bar, just before
    // the profile avatar, so the help icon participates in the flex layout.
    const headerEl = document.getElementById('emd-app-header')
    if (!headerEl) return

    const profileWrapper = headerEl.querySelector<HTMLElement>('[data-testid="profile-wrapper"]')
    if (!profileWrapper?.parentElement) return

    const container = document.createElement('div')
    container.setAttribute('data-testid', 'help-support-portal')
    container.className = 'help-support-portal'
    profileWrapper.parentElement.insertBefore(container, profileWrapper)
    setPortalTarget(container)

    return () => {
      container.remove()
      setPortalTarget(null)
    }
  }, [])

  return (
    <div data-testid="app-header-v2" id="emd-app-header">
      <AppHeaderV2 {...props} />
      {portalTarget && createPortal(<HelpSupportPopover />, portalTarget)}
    </div>
  )
}

export default AppHeaderV2Wrapper
